<template>
  <div class="flex number-input-wrapper" :class="{ hasUnit: unit }">
    <vs-input
      :value="value"
      @input="handleInput"
      @keypress="isNumber"
      @change="$emit('change', $event.target.value)"
      type="number"
      class="w-full"
      :disabled="disabled"
    />
    <div
      v-if="unit"
      class="py-2 border border-l-0 border-solid rounded-r right-side-input whitespace-no-wrap"
      :class="[
        {
          'px-1': compact,
        },
        {
          'px-3': !compact,
        },
        {
          disabled: disabled,
        },
      ]"
    >
      {{ unit }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      default: null,
    },
    unit: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  methods: {
    // Ensure number with dot as decimal separator
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 44 && // ,
        charCode !== 46 // .
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    handleInput(newValue) {
      let value = newValue;
      if (this.min !== null && value < this.min) {
        value = this.min;
      }
      if (this.max !== null && value > this.max) {
        value = this.max;
      }
      this.$emit("input", value);
    },
  },
  emits: ["input", "change"],
};
</script>

<style lang="scss" scoped>
.number-input-wrapper.hasUnit::v-deep {
  .vs-input--input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .right-side-input {
    border-color: rgba(0, 0, 0, 0.2);
    background-color: #f8f8f8;

    &.disabled {
      color: #999;
      border-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>

